const mapApiTenantSettingsToForm = tenantSettings => {
  if (!tenantSettings || typeof tenantSettings !== "object" || Array.isArray(tenantSettings)) return null

  return {
    currency: tenantSettings.currency ?? "",
    timeZone: tenantSettings.timezone ?? tenantSettings.timeZone ?? "",
    defaultLanguage: tenantSettings.language ?? tenantSettings.defaultLanguage ?? "",
    emailNotifications: !!tenantSettings.enableEmailNotifications,
    whatsappNotifications: !!tenantSettings.enableWhatsAppNotifications,
  }
}

const isNonEmptyValue = value => value != null && String(value).trim() !== ""

const mapRegistrationAdminToForm = registration => ({
  adminName: registration?.adminName ?? "",
  adminEmail: registration?.adminEmail ?? "",
  adminPhone: registration?.adminPhone ?? "",
})

const hasRegistrationAdminData = registration =>
  !!registration &&
  isNonEmptyValue(registration?.adminName) &&
  isNonEmptyValue(registration?.adminEmail) &&
  isNonEmptyValue(registration?.adminPhone)

const getTenantSettingsSource = data => {
  return (
    data?.tenantSettings ??
    data?.registration?.tenantSettings ??
    data?.registration?.tenantSettingsJson ??
    data?.tenantSettingsConfig
  )
}

const developerPortalStepperPrefillTransformer = res => {
  const data = res?.data ?? res
  const registration = data?.registration
  const tenantSettings = getTenantSettingsSource(data)

  return {
    ...data,
    adminDetailsLocked: !!registration?.adminDetailsLocked,
    hasRegistrationAdminData: hasRegistrationAdminData(registration),
    registrationAdminValues: mapRegistrationAdminToForm(registration),
    tenantSettingsFormValues: mapApiTenantSettingsToForm(tenantSettings),
  }
}

export default developerPortalStepperPrefillTransformer
